import { GraphDetails } from "../../api";
import { mergeArrays } from "../../utils/merge-arrays";

export const mergeGraphContent = (
  currentGraphContent: GraphDetails,
  newGraphContent: GraphDetails,
): GraphDetails => {
  return {
    clusters: mergeArrays(
      currentGraphContent.clusters ?? [],
      newGraphContent.clusters ?? [],
    ),
    edges: mergeArrays(currentGraphContent.edges, newGraphContent.edges),
    nodes: mergeArrays(currentGraphContent.nodes, newGraphContent.nodes),
  };
};
